import { createBrowserRouter } from "react-router";
import App from "./App";
import { SelectVortrag } from "./Pages/SelectVortrag";
import { Danke } from "./Pages/Danke";
import { Formular } from "./Pages/Formular";
import { ErrorElement } from "./Components/Error";
import { Cancelation } from "./Pages/Cancelation";
import { Admin } from "./Pages/Admin";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorElement />,
    children: [
      {
        path: "/",
        element: <SelectVortrag />,
      },
      {
        path: "anmelden/:vortragId",
        element: <Formular />,
      },
      {
        path: "anmelden/:vortragId/danke",
        element: <Danke />,
      },
      {
        path: "abmelden/:registrationId",
        element: <Cancelation />,
      },
      {
        path: "admin",
        element: <Admin />,
      },
    ],
  },
]);
